module.exports = __webpack_public_path__ + "static/media/HB2@2x.5ebfaada.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/HB/HB2@2x.png
// module id = 276
// module chunks = 0